import React from "react";
import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Typography,
} from "@material-ui/core";
import ExploreOffIcon from "@material-ui/icons/ExploreOff";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4, 2),
  },
  content: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  spaceAfter: {
    marginBottom: 15,
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

export const NotFound = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root} component="main">
      <CssBaseline />
      <Container maxWidth="xs">
        <div className={classes.content}>
          <Avatar className={classes.avatar}>
            <ExploreOffIcon />
          </Avatar>
          <Typography component="h1" variant="h5" className={classes.spaceAfter}>
            Page not found
          </Typography>
          <Typography variant="body1" color="textSecondary" className={classes.spaceAfter}>
            That page doesn't exist - double-check the link, or head back
            to familiar ground.
          </Typography>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            href="/"
          >
            Go to PlanPraise
          </Button>
        </div>
      </Container>
    </Box>
  );
};

export default NotFound;
